/**
 * Created by Jerker Nord on 2020-06-24.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {MonkeysGoldAllReelsWinParticles} from "./MonkeysGoldAllReelsWinParticles";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {BitmapTextStyleData} from "../../symbols/MonkeysGoldBitmapText";

export class MonkeysGoldAllReelsFilledWinView extends BaseView {

    private _diceComing:PIXI.spine.Spine;
    private _diceStart:PIXI.spine.Spine;
    private _diceAnimation:PIXI.spine.Spine;
    private _diceWin:PIXI.spine.Spine;
    private _diceWinContainer:PIXI.Container;
    private _diceWinShine:PIXI.spine.Spine;
    private _particles:MonkeysGoldAllReelsWinParticles;
    private _particlesContainer:PIXI.Container;
    private _winMultiplier:number;
    private _winAmountText:PIXI.BitmapText;
    private _orientation:string;
    private _diceAnimationTL:TimelineLite;
    private _diceMoveAndScaleAnimationTL:TimelineLite;
    private _diceMoving:PIXI.spine.Spine;
    private _winAmountStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUp",
        fontSize : 50
    };
    private _clicker:PIXI.Graphics;
    private _isAborted:boolean = false;

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.FREESPIN_INTRO.name).addChild(this);
        this._particlesContainer = new PIXI.Container();
        this._particles = new MonkeysGoldAllReelsWinParticles(this._particlesContainer);
        this._diceWinContainer = new PIXI.Container;
        this.addChild(this._diceWinContainer);
    }

    protected initAnimations():void {
        this._clicker = new PIXI.Graphics();
        this._clicker.on('pointertap', () => this.onAbortClick(), this);
        this._clicker.interactive = true;
        this._clicker.buttonMode = true;

        this.addChild(this._particlesContainer);

        this._diceComing = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceComing"));
        this._diceComing.visible = false;
        this.addChild(this._diceComing);
        this._diceComing.position.set(360, 300);

        this._diceStart = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceStart"));
        this._diceStart.visible = false;
        this.addChild(this._diceStart);
        this._diceStart.position.set(360, 300);
        this._diceStart.skeleton.setSkin(null);

        this._diceAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceAnimation"));
        this._diceAnimation.visible = false;
        this.addChild(this._diceAnimation);
        this._diceAnimation.position.set(360, 300);

        this._diceWin = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceWin"));
        this._diceWin.visible = false;
        this._diceWinContainer.addChild(this._diceWin);
        this._diceWinContainer.position.set(360, 340);

        this._diceMoving = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceMoving"));
        this._diceMoving.position.set(360, 370);
        this._diceMoving.visible = false;
        this.addChild(this._diceMoving);

        this._diceWinShine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineDiceWinShine"));
        this._diceWinShine.visible = false;
        this.addChild(this._diceWinShine);
        this._diceWinShine.position.set(360, 500);

        this._winAmountText = new PIXI.BitmapText("", this._winAmountStyle);
        this._winAmountText.anchor = new PIXI.Point(0.5, 0.5);
        this._winAmountText.position.set(340, 480);
        this._winAmountText.visible = false;
        this.addChild(this._winAmountText);
    }

    private onAbortClick():void {
        if(this._isAborted == true) {
            return;
        }
        this._isAborted = true;
        this.removeChild(this._clicker);
        if(this._diceAnimationTL && this._diceAnimationTL.isActive()) {
            this._diceAnimationTL.pause();
            this._diceAnimationTL.kill();
        }

        this._particles.start();
        new TweenLite(Reels.getReel(0)?.view, 0.3, {alpha : 0});
        new TweenLite(Reels.getReel(1)?.view, 0.3, {alpha : 0});
        new TweenLite(Reels.getReel(2)?.view, 0.3, {alpha : 0});
        new TweenLite(Reels.getReel(3)?.view, 0.3, {alpha : 0});
        new TweenLite(Reels.getReel(4)?.view, 0.3, {alpha : 0});
        new TweenLite(Reels.getReel(5)?.view, 0.3, {alpha : 0});

        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.DICE_START);
        this._diceComing.visible = false;
        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.DICE_ANTICIPATION);

        this._diceStart.visible = false;
        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.DICE_ENDS);
        this._diceAnimation.visible = false;

        this.removeChild(this._clicker);
        this.getLastPartTL();
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        if(this._diceWin && this._diceWin.visible == true) {
            if(this._diceMoveAndScaleAnimationTL && this._diceMoveAndScaleAnimationTL.isActive()) {
                this._diceMoveAndScaleAnimationTL.pause();
                this._diceMoveAndScaleAnimationTL.kill();
                this._diceMoving.visible = false;
            }
        }
        const leftOffset:number = Math.floor(-this.x / this.scale.x);
        const topOffset:number = Math.floor(-this.y / this.scale.y);
        this._clicker.clear();
        this._clicker.beginFill(0xFF0000, 1);
        this._clicker.alpha = 0;
        this._clicker.drawRect(leftOffset, topOffset, Math.ceil(resizeData.width / this.scale.x), Math.ceil(resizeData.height / this.scale.y));
    }

    public getBonusGameDiceAnimationTL(winMultiplier:number):TimelineLite {
        this._winMultiplier = winMultiplier;
        this._diceAnimationTL = new TimelineLite();
        //Abort possible starts
        this._diceAnimationTL.add(() => this.addChild(this._clicker));
        this._diceAnimationTL.add([
            () => this._particles.start(),
            new TweenLite(Reels.getReel(0)?.view, 0.3, {alpha : 0}),
            new TweenLite(Reels.getReel(1)?.view, 0.3, {alpha : 0}),
            new TweenLite(Reels.getReel(2)?.view, 0.3, {alpha : 0}),
            new TweenLite(Reels.getReel(3)?.view, 0.3, {alpha : 0}),
            new TweenLite(Reels.getReel(4)?.view, 0.3, {alpha : 0}),
            new TweenLite(Reels.getReel(5)?.view, 0.3, {alpha : 0}),
        ]);
        this._diceAnimationTL.add(() => this._diceComing.updateTransform());
        this._diceAnimationTL.add(() => this._diceComing.visible = true);
        this._diceAnimationTL.add(() => this._diceComing.skeleton.setSlotsToSetupPose());
        this._diceAnimationTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.DICE_START)}));
        this._diceAnimationTL.add(new SpineTween(this._diceComing, 0, "block_move_left_animation", 0));
        this._diceAnimationTL.add(() => this._diceComing.visible = false);
        this._diceAnimationTL.add(() => this._diceStart.updateTransform());
        this._diceAnimationTL.add(() => this._diceStart.visible = true);
        this._diceAnimationTL.add(() => this._diceStart.skeleton.setSlotsToSetupPose());
        this._diceAnimationTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.DICE_ANTICIPATION)}));
        this._diceAnimationTL.add(new SpineTween(this._diceStart, 0, "start", 0));
        this._diceAnimationTL.add(() => this._diceStart.visible = false);
        this._diceAnimationTL.add(() => this._diceAnimation.updateTransform());
        this._diceAnimationTL.add(() => this._diceAnimation.visible = true);
        this._diceAnimationTL.add(() => this._diceAnimation.skeleton.setSlotsToSetupPose());
        this._diceAnimationTL.add(new SpineTween(this._diceAnimation, 0, "dice_animation", 3));
        this._diceAnimationTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.DICE_ANTICIPATION));
        this._diceAnimationTL.add(() => this._diceAnimation.visible = false);
        this._diceAnimationTL.add(() => this.removeChild(this._clicker));
        //Abort possible ends
        this._diceAnimationTL.add(this.getLastPartTL());
        return this._diceAnimationTL;
    }

    private getLastPartTL():TimelineLite {
        const lastPartTL:TimelineLite = new TimelineLite();
        lastPartTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.DICE_ENDS)}));
        lastPartTL.add(() => this._diceWin.updateTransform());
        lastPartTL.add(() => this._diceWin.visible = true);
        lastPartTL.add(() => this._diceWin.skeleton.setSkin(null));
        lastPartTL.add(() => this._diceWin.skeleton.setSkinByName("x" + this._winMultiplier + "_win"));
        lastPartTL.add(() => this._diceWin.skeleton.setSlotsToSetupPose());
        lastPartTL.add(new SpineTween(this._diceWin, 0, "win", 0));
        lastPartTL.add(TweenLite.to(this._diceWin, 0.2, {alpha : 0}));
        lastPartTL.add(this.getDiceToMultiplierTL(), "-=0.2");
        lastPartTL.add(MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView.initMultiplierValue(this._winMultiplier), "-=0.2");
        lastPartTL.add(() => this.restoreDice());
        lastPartTL.add([
            () => MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.endBottomFire(),
            new TweenLite(Reels.getReel(0)?.view, 0.4, {alpha : 1}),
            new TweenLite(Reels.getReel(1)?.view, 0.4, {alpha : 1}),
            new TweenLite(Reels.getReel(2)?.view, 0.4, {alpha : 1}),
            new TweenLite(Reels.getReel(3)?.view, 0.4, {alpha : 1}),
            new TweenLite(Reels.getReel(4)?.view, 0.4, {alpha : 1}),
            new TweenLite(Reels.getReel(5)?.view, 0.4, {alpha : 1}),
            () => this._particles.stop()
        ], "-=0.2");
        lastPartTL.add(() => this._diceMoving.visible = false);
        //Normally dispatched in FS intro controller
        lastPartTL.add(() => EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED)), "+=1");
        return lastPartTL;
    }

    private getDiceToMultiplierTL():TimelineLite {
        this._diceMoveAndScaleAnimationTL = new TimelineLite();
        this._diceMoveAndScaleAnimationTL.add(() => this._diceMoving.skeleton.setSlotsToSetupPose());
        this._diceMoveAndScaleAnimationTL.add(() => this._diceMoving.updateTransform());
        this._diceMoveAndScaleAnimationTL.add(() => this._diceMoving.visible = true);
        this._diceMoveAndScaleAnimationTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.DICE_MULTIPLIER_SWEEP)}));
        if(this._orientation == Orientation.LANDSCAPE) {
            this._diceMoveAndScaleAnimationTL.add(new SpineTween(this._diceMoving, 0, "landscape_animation", 0));
        } else {
            this._diceMoveAndScaleAnimationTL.add(new SpineTween(this._diceMoving, 0, "portrait_animation", 0));
        }
        return this._diceMoveAndScaleAnimationTL;
    }

    public restoreDice():void {
        this._diceWin.visible = false;
        this._diceWin.alpha = 1;
        this._diceWinContainer.scale.set(1, 1);
        this._diceWinContainer.position.set(360, 340);
        this._isAborted = false;
    }
}